import { HIDE_MODAL } from '../state-constants/stateConstants';

export const hideModal = bool => ({
  type: HIDE_MODAL,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/hideModal.js